import styled from '../../../../styled-components';
import device from '../devices';
import { Button } from './Button';
import { themeGet } from '@styled-system/theme-get';

export const PrimaryButton = styled(Button)`
  background: ${themeGet('colors.primary')};
  border-radius: 4px;
  color: ${themeGet('colors.primaryOn')};
  fill: ${themeGet('colors.primaryOn')};
  white-space: nowrap;
  height: 36px;
  line-height: 32px;
  padding: 0 16px;
  outline: none;
  align-items: center;

  &:focus:enabled {
    box-shadow: 0 0 0 1px ${themeGet('colors.surface')}, 0 0 0 3px ${themeGet('colors.primary')};
  }

  &:hover:enabled {
    background: ${themeGet('colors.hover.primary')};
  }

  &:disabled {
    background: ${themeGet('colors.primaryScale.100')};
  }

  @media ${device.mobile} {
    height: 32px;
    line-height: 28px;
  }
`;
